module.exports = __webpack_public_path__ + "static/media/How to change branch or company information.aa4d7b2a.png";